export default __webpack_public_path__ + "static/media/DISS-CO_TOM_20230820.2fbccf2d.pdf";